import { useNavigate } from 'react-router-dom';

export default function WrappedTeaserCard({ userId, year }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/users/${userId}/wrapped/${year}`);
  };

  return (
    <div
      onClick={handleClick}
      className='my-3'
      style={{
        cursor: 'pointer',
        borderRadius: '18px',
        padding: '24px',
        background: `
          var(--theme-primary-gradient)
        `,
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        boxShadow: '0 10px 30px rgba(255,95,162,0.35)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      }}
      onTouchStart={() => {}}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.02)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <div style={{ fontSize: '14px', fontWeight: 600, opacity: 0.85 }}>
        Tu año en GP 💗
      </div>

      <div style={{ fontSize: '22px', fontWeight: 800 }}>
        Mira tu Wrapped {year}
      </div>

      <div style={{ fontSize: '15px', opacity: 0.85 }}>
        Clases favoritas, horas entreandas & tu mejor mes 🚀
      </div>

      <div
        style={{
          alignSelf: 'flex-end',
          fontSize: '14px',
          fontWeight: 700,
        }}
      >
        Tap para ver →
      </div>
    </div>
  );
}
